import type { PropertyData } from "libs/codegen/property-onboarding";
import { useMemo } from "react";
import { useFormContext } from "react-hook-form";

export const usePropertyDescriptionPrefill = () => {
    const { getValues } = useFormContext<PropertyData>();

    const values = useMemo(() => getValues(), []);

    return {
        name: `${values?.bedrooms?.length} Bed ${values.bathrooms} Bath in ${values.city.name}`,
        city: values.city.name,
        state: values.state.name,
    };
};
